/**
 * Cursor glow - halo doré qui suit la souris sur toute la page.
 */

export function initCursorGlow(): () => void {
  if ('ontouchstart' in window) return () => {};

  const glow = document.createElement('div');
  glow.className = 'cursor-glow';
  document.body.appendChild(glow);

  function onMove(e: MouseEvent) {
    glow.style.transform = `translate(${e.clientX}px, ${e.clientY}px)`;
  }

  document.addEventListener('mousemove', onMove);

  return () => {
    document.removeEventListener('mousemove', onMove);
    glow.remove();
  };
}
